<template>
	<div>
		<div class="match">
			<div class="wrapper">
				<div class="match_heading">События {{ getDate() }}</div>
				
				<div class="match_row">
					<tournaments :type="type"></tournaments>
					
					<div class="match_right">
						<div class="tab">
							<match-header></match-header>
							
							<live-header @dateSelected="changeData" :type="type"></live-header>
							
							<div class="tab_content">
								<div class="tab_block active" id="block-1">
									<matches :type="type" v-if="list" :list="list"></matches>
									<div class="info-text" v-else style="padding-top: 20px;">Загрузка...</div>
								</div>
								<div class="tab_block" id="block-2">
									<matches :type="type" :list="list" filter="inprogress"></matches>
								</div>
								<div class="tab_block" id="block-3">
									<matches :type="type" :list="list" filter="finished"></matches>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import moment from 'moment';
	
	import Tournaments from "../components/Tournaments/Tournaments";
	import MatchHeader from "../components/Match/MatchHeader";
	import LiveHeader from "../components/Live/LiveHeader";
	import Matches from "../components/Match/Matches";
	
	export default {
		components: {
			Tournaments,
			MatchHeader,
			LiveHeader,
			Matches
		},
		
		data() {
			return {
				type: this.$route.params.sport,
				currentDate: moment().format('Y-M-D'),
				list: null
			}
		},
		
		created() {
			this.update();
		},
		
		methods: {
			changeData(date) {
				this.$router.push({
					name: 'live-sport',
					params: {
						sport: this.$route.params.sport
					},
					query: {
						day: date
					}
				});
				
				this.getData(date);
			},
			
			getData(date) {
				this.axios.get('/api/events?sport=' + this.type + '&day=' + date)
					.then(({data}) => {
						this.list = data;
					});
			},
			
			getCurrentDate() {
				if (!this.$route.query.day) {
					return moment().format('Y-M-D');
				}
				
				return this.$route.query.day;
			},
			
			getDate() {
				let date = this.$route.query.day;
				
				if (!date) {
					return 'сегодня';
				}
				
				return moment(this.$route.query.day).locale("ru").format('DD MMMM Y');
			},
			
			update() {
				if (this.type !== this.$route.params.sport) return;
				
				this.getData(this.getCurrentDate());
				
				setTimeout(() => {
					this.update();
				}, 1000 * 60);
			}
		}
	}
</script>